import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Instagram } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-ink-600 bg-ink-900 mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <h3 className="font-display text-4xl text-brand">BLAZING EDGE BBQ</h3>
          <p className="font-display text-cream text-lg tracking-[0.3em] mt-1">LIVE LIFE ON THE EDGE</p>
          <p className="text-[#A19D94] mt-6 max-w-md leading-relaxed">
            Low and slow craft barbeque, smoked over hardwood on the NSW Central Coast. Pickup only at Gosford Showgrounds.
          </p>
        </div>

        <div>
          <h4 className="font-display text-xl text-cream tracking-widest mb-4">EXPLORE</h4>
          <ul className="space-y-3 text-[#A19D94]">
            <li><Link to="/shop" className="hover:text-brand transition-colors">Shop</Link></li>
            <li><Link to="/about" className="hover:text-brand transition-colors">Our Story</Link></li>
            <li><Link to="/pickup" className="hover:text-brand transition-colors">Pickup</Link></li>
            <li><Link to="/admin/login" className="hover:text-brand transition-colors">Admin</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl text-cream tracking-widest mb-4">FIND US</h4>
          <ul className="space-y-3 text-[#A19D94]">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-1 text-brand" /> Gosford Showgrounds, NSW</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-1 text-brand" /> hello@blazingedge.bbq</li>
            <li className="flex items-start gap-2"><Instagram size={16} className="mt-1 text-brand" /> @blazingedgebbq</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ink-600">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-sm text-[#A19D94]">
          <span>© {new Date().getFullYear()} Blazing Edge BBQ. All rights reserved.</span>
          <span className="font-display tracking-[0.3em] text-brand">SMOKE • FIRE • EDGE</span>
        </div>
      </div>
    </footer>
  );
};
